var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.462 10.951H4.846v-1h10.615l-5.427-5.428.707-.707 6.634 6.635-6.634 6.634-.707-.707 5.428-5.427z","id":"path-1"}));
}

Arrow.displayName = "Arrow";

Arrow.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21"};

module.exports = Arrow;

Arrow.default = Arrow;
